import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaPhone, FaEnvelope, FaClock, FaMapMarkerAlt } from "react-icons/fa";

const Contact = () => {
  return (
    <Container id="contact" className="py-5">
      <h2
        className="text-center fw-bold mb-4"
        style={{ color: "#8b5e3c", fontFamily: "'Segoe UI', sans-serif" }}
      >
        Contact Us
      </h2>

      <Row className="justify-content-center align-items-start">
        
        {/* Contact Details */}
        <Col lg={6} className="mb-4">
          <Card className="p-4 shadow-sm rounded" style={{ backgroundColor: "#fff" }}>
            
            <h5 className="fw-bold mb-3" style={{ color: "#8b5e3c" }}>
              Get in Touch
            </h5>

            <p className="mb-2">
              <FaPhone className="me-2" style={{ color: "#8b5e3c" }} />
              +27 78 479 6342
            </p>

            <p className="mb-2">
              <FaEnvelope className="me-2" style={{ color: "#8b5e3c" }} />
              admin@ndlebeattorneys.co.za
            </p>

            <p className="mb-2">
              <FaMapMarkerAlt className="me-2" style={{ color: "#8b5e3c" }} />
              19 Seder Street, Extension 1, Winchester Hills, Johannesburg, 2091
            </p>

            <p className="mb-3">
              <FaClock className="me-2" style={{ color: "#8b5e3c" }} />
              Mon – Fri: 08:00 – 17:00
            </p>

            {/* 🔥 NEW ADDRESS BLOCK */}
            <div
            className="mt-4 p-3 rounded"
            style={{
                background: "#f8f9fa",
                borderLeft: "4px solid #8b5e3c",
            }}
            >
            <h6 className="fw-bold mb-2" style={{ color: "#8b5e3c" }}>
                Visit Our Office
            </h6>

            <a
                href="https://www.google.com/maps?q=19+Seder+Street+Extension+1+Winchester+Hills+Johannesburg"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "#000" }}
            >
                19 Seder Street <br />
                Extension 1, Winchester Hills <br />
                Johannesburg
            </a>
            </div>

          </Card>
        </Col>

        {/* Google Map */}
        <Col lg={6} className="mb-4">
        <div className="shadow-sm rounded overflow-hidden">
            <iframe
            title="Office Location"
            src="https://www.google.com/maps?q=19+Seder+Street+Extension+1+Winchester+Hills+Johannesburg&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0, minHeight: "400px" }}
            allowFullScreen=""
            loading="lazy"
            ></iframe>
        </div>
        </Col>

      </Row>
    </Container>
  );
};

export default Contact;